module.exports = __webpack_public_path__ + "static/img/about-profile-img.ffadf22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutpic/about-profile-img.jpg
// module id = OgEm
// module chunks = 51